import * as React from "react"
import { useContext } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Card,
  Container,
  AccordionContext,
  useAccordionButton,
} from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion"
import List from "./elements/list"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faMinus } from "@fortawesome/pro-regular-svg-icons"

const ContextAwareToggle = ({ children, eventKey, callback }) => {
  const { activeEventKey } = useContext(AccordionContext)

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  )

  const isCurrentEventKey = activeEventKey === eventKey

  return (
    <div className="accordion-toggle" onClick={decoratedOnClick}>
      {children}
      <FontAwesomeIcon
        icon={isCurrentEventKey ? faMinus : faPlus}
        size="xs"
        color={isCurrentEventKey ? "#3C3E44" : "#B1B2B4"}
      />
    </div>
  )
}

const Accordions = ({ padding, content }) => {
  return (
    <Container
      style={{
        padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
      }}
    >
      <Row className="mb-4">
        <Accordion defaultActiveKey={1}>
          <Card>
            {content.map((accordion, i) => {
              return (
                <div className="accordion-wrapper" key={i}>
                  <Card.Header>
                    <ContextAwareToggle eventKey={i + 1}>
                      {accordion.title}
                    </ContextAwareToggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={i + 1}>
                    <div className="accordion-collapse">
                      <p>{accordion.text === "" ? null : accordion.text}</p>
                      {accordion.list === undefined ? null : (
                        <List listItems={accordion.list} type="" />
                      )}
                      {accordion.text_2 === undefined ? null : (
                        <p className="">{accordion.text_2}</p>
                      )}
                      {accordion.list_2 === undefined ? null : (
                        <List listItems={accordion.list_2} type="" />
                      )}
                    </div>
                  </Accordion.Collapse>
                </div>
              )
            })}
          </Card>
        </Accordion>
      </Row>
    </Container>
  )
}

Accordions.propTypes = {
  content: PropTypes.array,
  padding: PropTypes.object,
}

export default Accordions
